import * as React from 'react';
import clsx from 'clsx';

import { LocationShape, StartTime } from 'lib/util/productShape';
import { applyRelativeTimeOffset } from 'lib/util/applyRelativeTimeOffset';
import { LinkableTextArea } from 'components/LinkableTextArea/LinkableTextArea';

interface Props {
  startTime?: StartTime;
  locations: LocationShape[];
}

export const LocationList = ({ startTime, locations }: Props) => {
  return (
    <ul className="c-schedule__list">
      {locations.map((location) => {
        const dedicatedStartTimeItem = location.dedicatedStartTimeInfoItems.find(
          (item) => item.timeSlotKey === startTime?.timeSlotKey
        );

        let timeRelative = location.timeRelative;
        if (dedicatedStartTimeItem && dedicatedStartTimeItem.timeRelative) {
          timeRelative = dedicatedStartTimeItem.timeRelative;
        }
        const timeDescription = timeRelative
          ? applyRelativeTimeOffset(startTime?.hhMm || '0:00', timeRelative)
          : '';

        return (
          <li key={location.name} className="c-schedule__list__item">
            <p className="c-schedule__list__item__time">{timeDescription}</p>
            <div className="c-schedule__list__item__body">
              <p className="c-schedule__list__item__body__title">
                <a
                  href={`https://www.google.com/maps/search/?api=1&query_place_id=${location.googlePlaceID}&query=${location.name}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {location.name}
                </a>
              </p>
              <p className={clsx('c-schedule__list__item__body__text', 'newline')}>
                <LinkableTextArea>{location.description}</LinkableTextArea>
              </p>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
